(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hm-store-header')) {
  class HMStoreHeader extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.frame = 0;
      this.position = 0;
      this.velocity = 0;
      this.target = 0;
      this.mobile = this.querySelector('[data-hm-mobile]');
      this.trigger = this.mobile.querySelector('summary');
      this.panel = this.querySelector('[data-hm-drawer]');
      this.mega = this.querySelector('[data-hm-mega]');
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'hm-dialog';
      this.dialog.setAttribute('aria-label', this.querySelector('.hm-desktop-nav').getAttribute('aria-label'));
      this.dialog.dir = this.dir;
      this.dialog.append(this.panel);
      this.append(this.dialog);
      this.classList.add('is-enhanced');
      this.selectCategory('0');
      this.breakpoint = matchMedia('(min-width: 1024px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.listen(this.trigger, 'click', event => {
        event.preventDefault();
        this.setDrawer(this.target !== 1);
      });
      this.listen(this.querySelector('[data-hm-close]'), 'click', () => this.setDrawer(false));
      this.listen(this.dialog, 'cancel', event => {
        event.preventDefault();
        this.setDrawer(false);
      });
      this.listen(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.setDrawer(false);
      });
      this.listen(this.dialog, 'close', () => this.finishClose());
      this.listen(this.breakpoint, 'change', () => {
        this.mega.open = false;
        if (this.breakpoint.matches) this.setDrawer(false, true);
      });
      this.listen(this.reducedMotion, 'change', () => {
        if (this.dialog.open) this.setDrawer(this.target === 1, true);
      });
      this.listen(document, 'pointerdown', event => {
        if (!this.mega.contains(event.target)) this.mega.open = false;
      });
      this.listen(this.mega, 'keydown', event => {
        if (event.key === 'Escape') {
          this.mega.open = false;
          this.mega.querySelector('summary').focus();
        }
      });
      this.listen(this.mega, 'toggle', () => {
        this.mega.querySelector('summary').setAttribute('aria-expanded', String(this.mega.open));
        if (this.mega.open) this.fitMega();
      });
      this.listen(window, 'resize', () => { if (this.mega.open) this.fitMega(); });
      this.listen(this.mega, 'focusout', () => {
        setTimeout(() => {
          if (this.isConnected && !this.mega.contains(document.activeElement)) this.mega.open = false;
        });
      });
      this.querySelectorAll('[data-hm-category]').forEach(button => {
        this.listen(button, 'click', () => this.selectCategory(button.dataset.hmCategory));
        this.listen(button, 'keydown', event => {
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const buttons = [...this.querySelectorAll('[data-hm-category]')];
          let index = buttons.indexOf(button);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = buttons.length - 1;
          else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[index].focus();
          this.selectCategory(buttons[index].dataset.hmCategory);
        });
      });
      this.querySelectorAll('[data-hm-category-link]').forEach(link => {
        this.listen(link, 'pointerenter', event => {
          if (event.pointerType === 'mouse') this.selectCategory(link.dataset.hmCategoryLink);
        });
        this.listen(link, 'focus', () => this.selectCategory(link.dataset.hmCategoryLink));
      });
      const dismiss = this.querySelector('[data-hm-dismiss]');
      if (dismiss) this.listen(dismiss, 'click', () => {
        this.querySelector('[data-hm-announcement]').hidden = true;
        this.querySelector('.hm-logo').focus();
        if (this.mega.open) this.fitMega();
      });
      this.querySelectorAll('[data-hm-language]').forEach(select => this.listen(select, 'change', () => select.form.requestSubmit()));
      this.listen(document, 'shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.hmSection && this.breakpoint.matches) this.mega.open = true;
      });
    }
    listen(target, name, handler) {
      target.addEventListener(name, handler, { signal: this.signal });
    }
    fitMega() {
      const surface = this.querySelector('[data-hm-mega-surface]');
      surface.style.height = `${Math.max(180, Math.min(640, innerHeight - surface.getBoundingClientRect().top - 20))}px`;
      surface.style.minHeight = '0';
    }
    selectCategory(index) {
      this.querySelectorAll('[data-hm-panel]').forEach(panel => { panel.hidden = panel.dataset.hmPanel !== index; });
      this.querySelectorAll('[data-hm-category]').forEach(button => {
        const selected = button.dataset.hmCategory === index;
        button.setAttribute('aria-expanded', String(selected));
        button.closest('.hm-category-row').classList.toggle('is-active', selected);
      });
    }
    lockScroll() {
      if (this.locked) return;
      this.savedBody = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width, overflow: document.body.style.overflow };
      this.savedScroll = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.savedScroll}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      this.locked = true;
    }
    unlockScroll() {
      if (!this.locked) return;
      Object.assign(document.body.style, this.savedBody);
      const oldBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, this.savedScroll);
      document.documentElement.style.scrollBehavior = oldBehavior;
      this.locked = false;
    }
    setDrawer(open, instant = false) {
      this.target = open ? 1 : 0;
      if (open && !this.dialog.open) {
        this.lockScroll();
        this.dialog.showModal();
        this.querySelector('[data-hm-close]').focus({ preventScroll: true });
      }
      this.trigger.setAttribute('aria-expanded', String(open));
      if (!this.dialog.open) return;
      cancelAnimationFrame(this.frame);
      if (instant) {
        this.position = this.target;
        this.velocity = 0;
        this.paint();
        if (!open) this.dialog.close();
        return;
      }
      let last = performance.now();
      const step = now => {
        const elapsed = Math.min((now - last) / 1000, .032);
        last = now;
        if (this.reducedMotion.matches) {
          this.position += (this.target - this.position) * Math.min(1, elapsed * 35);
        } else {
          const steps = Math.max(1, Math.ceil(elapsed / .008));
          const dt = elapsed / steps;
          for (let i = 0; i < steps; i++) {
            this.velocity += (420 * (this.target - this.position) - 41 * this.velocity) * dt;
            this.position += this.velocity * dt;
          }
        }
        if (Math.abs(this.target - this.position) < .001 && Math.abs(this.velocity) < .01) {
          this.position = this.target;
          this.velocity = 0;
          this.paint();
          if (this.target === 0) this.dialog.close();
          return;
        }
        this.paint();
        this.frame = requestAnimationFrame(step);
      };
      this.paint();
      this.frame = requestAnimationFrame(step);
    }
    paint() {
      const progress = Math.max(0, Math.min(1, this.position));
      const sign = this.dir === 'rtl' ? 1 : -1;
      this.panel.style.transform = this.reducedMotion.matches ? 'none' : `translateX(${sign * (1 - progress) * 100}%)`;
      this.panel.style.opacity = this.reducedMotion.matches ? String(progress) : '1';
      this.dialog.style.setProperty('--hm-backdrop', String(progress * .28));
    }
    finishClose() {
      cancelAnimationFrame(this.frame);
      this.target = this.position = this.velocity = 0;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.unlockScroll();
      if (this.isConnected && !this.breakpoint.matches) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.frame);
      this.unlockScroll();
      if (this.dialog) {
        if (this.dialog.open) this.dialog.close();
        this.mobile.append(this.panel);
        this.dialog.remove();
      }
      this.classList.remove('is-enhanced');
    }
  }
  customElements.define('hm-store-header', HMStoreHeader);
}


  } catch(e) { console.error(e); }
})();
})();
